import * as React from 'react';
import {useParams} from 'react-router-dom';
import {AppContext} from '../../../context/AppProvider';
import withAlmToken from '../../common/withAlmToken';
import ProgramIntro from './ProgramIntro';

const Program = () => {
  const {state} = React.useContext(AppContext);
  const {courseId} = useParams();
  return (
    <>
      <div className="flex-grow">{state.user && courseId && <ProgramIntro cid={courseId} />}</div>
    </>
  );
};
export default withAlmToken(Program);
